import { HttpInterceptorFn } from '@angular/common/http';

/**
 * HTTP interceptor for adding correlation ID to requests.
 * CPNotes: Adds X-Correlation-ID header for request tracking
 */
export const correlationInterceptor: HttpInterceptorFn = (req, next) => {
  const correlationId = generateCorrelationId();
  
  const cloned = req.clone({
    setHeaders: {
      'X-Correlation-ID': correlationId
    }
  });

  return next(cloned);
};

/**
 * Generates a unique correlation ID.
 */
function generateCorrelationId(): string {
  return `${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
}

